import { configureStore } from '@reduxjs/toolkit';
import areaLevelReducer from './areaLevelSlice';
import diseaseReducer from "./diseaseSlice";
import weekOfYearReducer from './weekOfYearSlice';
import iaamReducer from './iaamSlice';
import profileReducer from './profileSlice';
import areaDataSlice from './areaDataSlice';
import morbidityRateSlice from './morbidityRateSlice';
import patientCompareSlice from './patientCompareSlice';
import patientSlice from './patientSlice';
import clusterSlice from './clusterSlice';
import spotmapSlice from './spotmapSlice';
import renderTypeSlice from './renderTypeSlice';
import areaSelectedSlice from './areaSelectedSlice';
import LarvaIndexSlice from './LarvaIndexSlice';
import mapDataSelectedSlice from './mapDataSelectedSlice';
import updateTimeSlice from './updateTimeSlice';
import mapSettingSlice from './mapSettingSlice';
import dengueSettingSlice from './dengueSettingSlice';

export default configureStore({
    reducer: {
        disease: diseaseReducer,
        weekofyear: weekOfYearReducer,
        arealevel: areaLevelReducer,
        iaam: iaamReducer,
        profile: profileReducer,
        patient: patientSlice,
        areadata: areaDataSlice,
        morbidity: morbidityRateSlice,
        compare: patientCompareSlice,
        cluster: clusterSlice,
        spotmap: spotmapSlice,
        rendertype: renderTypeSlice,
        areaselected: areaSelectedSlice,
        larvaindex: LarvaIndexSlice,
        mapdata: mapDataSelectedSlice,
        updatetime: updateTimeSlice,
        mapsetting: mapSettingSlice,
        denguesetting: dengueSettingSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
            // serializableCheck: {
            //     ignoredActions: true
            //     // Ignore these action types
            //     // ignoredActions: ['your/action/type'],
            //     // Ignore these field paths in all actions
            //     // ignoredActionPaths: ['iaam.valie', 'payload.timestamp'],
            //     // Ignore these paths in the state
            //     // ignoredPaths: ['items.dates'],
            // },
        }),
});
